import Decimal from 'decimal.js';

const ExactDecimal = Decimal.clone({ precision: 80, rounding: Decimal.ROUND_HALF_UP });
const DECIMAL_PATTERN = /^-?(?:\d+|\d*\.\d+)$/;

const parseDecimal = (value, strict = true) => {
  if (value === '' || value === null || value === undefined) {
    return null;
  }

  const normalized = String(value).trim().replace(',', '.');
  if ((strict && !DECIMAL_PATTERN.test(normalized)) || normalized === '') {
    return null;
  }

  try {
    const decimal = new ExactDecimal(normalized);
    return decimal.isFinite() ? decimal : null;
  } catch (error) {
    return null;
  }
};

export const normalizeExactDecimal = (value) => {
  const decimal = parseDecimal(value);
  return decimal === null ? null : decimal.toFixed();
};

export const calculateDecimal = (left, right, operation, precision) => {
  const leftDecimal = parseDecimal(left);
  const rightDecimal = parseDecimal(right);
  if (leftDecimal === null || rightDecimal === null) {
    return null;
  }

  if (operation === 'divide' && rightDecimal.isZero()) {
    return null;
  }

  const result = operation === 'divide'
    ? leftDecimal.dividedBy(rightDecimal)
    : leftDecimal.times(rightDecimal);
  const scale = Math.max(0, Number.parseInt(precision, 10) || 0);

  return result.toDecimalPlaces(scale, ExactDecimal.ROUND_HALF_UP).toFixed(scale);
};

export const formatDecimal = (value, precision) => {
  const decimal = parseDecimal(value, false);
  if (decimal === null) {
    return '';
  }

  const scale = Math.max(0, Number.parseInt(precision, 10) || 0);
  return decimal.toDecimalPlaces(scale, ExactDecimal.ROUND_HALF_UP).toFixed(scale);
};
